export const decode = encodedString => {
  if (!encodedString) return '';

  return typeof window !== 'undefined'
    ? atob(encodedString)
    : Buffer.from(encodedString, 'base64').toString();
};
